import React, {useEffect, useState} from 'react';
import classes from "./history.module.css";
import {getHistoryAPI} from "../../api";
import {CSSTransition} from "react-transition-group";

const History = ({historyOpen, setHistoryOpen}) => {
    const [history, setHistory] = useState([])
    async function getHistory(){
        const res = await getHistoryAPI()
        setHistory(res)
    }

    useEffect(()=>{
        getHistory()
    },[])

    function getDate(date){
        let dateOut = date.split('T')
        let date1 = dateOut[0].split('-')
        return date1[2]+'.'+date1[1]+'.'+date1[0]+' '+dateOut[1].split('.')[0].split('Z')[0]
    }

    return (
        <div className={classes._}>
            <CSSTransition in={historyOpen}
                           timeout={300}
                           classNames="openBlock"
                           unmountOnExit>
                <div className={classes.fon} onClick={()=>setHistoryOpen(false)}></div>
            </CSSTransition>
            <CSSTransition in={historyOpen}
                           timeout={300}
                           classNames="openBlock"
                           unmountOnExit>
                <div className={classes.block2}>
                    <div className={classes.close} onClick={()=>setHistoryOpen(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M11.9997 10.5865L16.2424 6.34382C16.6329 5.9533 17.2661 5.9533 17.6566 6.34382C18.0471 6.73435 18.0471 7.36751 17.6566 7.75803L13.4139 12.0007L17.6566 16.2433C18.0471 16.6338 18.0471 17.267 17.6566 17.6575C17.2661 18.048 16.6329 18.048 16.2424 17.6575L11.9997 13.4149L7.75706 17.6575C7.36654 18.048 6.73338 18.048 6.34286 17.6575C5.95233 17.267 5.95233 16.6338 6.34286 16.2433L10.5855 12.0007L6.34285 7.75804C5.95232 7.36751 5.95233 6.73435 6.34285 6.34382C6.73338 5.9533 7.36654 5.9533 7.75707 6.34383L11.9997 10.5865Z" fill="white"/>
                        </svg>
                    </div>
                    <div className={classes.block}>
                        <div className={classes.text1}>История пополнений</div>
                        <div className={classes.historyBlock}>
                            <table>
                                {history.map(item=>
                                    <tr className={classes.item} key={item.id}>
                                        <td className={classes.text2}>{getDate(item.date)}</td>
                                        <td className={classes.text2}>{item.sum}₽</td>
                                        <td className={classes.text2}>{item.comment}</td>
                                    </tr>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};

export default History;